(() => {
  const script = document.currentScript;
  const destination = script.dataset.enforcerUrl;
  const label = script.dataset.enforcerLabel;
  if (!destination) return;
  const matches = image => /\/IMG_5111(?:[_.?]|$)/i.test(image.getAttribute('src') || '') ||
    /\benforcer\b/i.test(image.getAttribute('alt') || '');
  const update = root => {
    const images = root instanceof HTMLImageElement ? [root] : [...root.querySelectorAll('img')];
    images.forEach(image => {
      if (!matches(image)) return;
      const existing = image.closest('a');
      if (existing) {
        if (existing.getAttribute('href') !== destination) existing.setAttribute('href', destination);
        existing.removeAttribute('target');
        return;
      }
      if (image.closest('button')) return;
      const link = document.createElement('a');
      link.href = destination;
      link.className = 'uc-enforcer-image-link';
      link.setAttribute('aria-label', label);
      image.before(link);
      link.append(image);
    });
  };
  update(document);
  new MutationObserver(records => {
    records.forEach(record => {
      if (record.type === 'attributes') update(record.target);
      else record.addedNodes.forEach(node => { if (node.nodeType === 1) update(node); });
    });
  }).observe(document.body, {subtree:true,childList:true,attributes:true,attributeFilter:['src','alt']});
})();
